import { type FC } from 'react';

import { makePortalGlobalChannel, SocketEvent } from '@furality/centrifugo-types';
import MessageTypes, { isToastPacket } from '@/components/socket/SocketMessages.ts';
import useChannelEventSubscription from '@/lib/hooks/useChannelEventSubscription.ts';
import useToasts from '@/lib/useToast';

const PortalUserNotificationsListener: FC = () => {
  const channel = makePortalGlobalChannel();
  const { pushToast } = useToasts();

  useChannelEventSubscription(channel, SocketEvent.Toast, (data: unknown) => {
    if (isToastPacket(data)) {
      pushToast(data.type, data.message, data.duration);
    }
  });

  useChannelEventSubscription(channel, MessageTypes.ReloadApplication, () => {
    console.warn('Reload triggered, refresh pending');
    setTimeout(
      () => {
        window.location.reload();
      },
      Math.floor(Math.random() * 60000), // Random timeout of up to 60 seconds
    );
  });

  // This is just for silly, prefer to use the prior one so it doesn't destroy the system
  useChannelEventSubscription(channel, MessageTypes.ReloadApplicationForce, () => {
    window.location.reload();
  });

  return null;
};

export default PortalUserNotificationsListener;
